import { Log, apiRequest } from '@ext/utils';
import { Paginacion } from '@ext/env';
export * from './Recurso.types';
import { IRecurso } from './Recurso.lib';

export class Recurso extends IRecurso
{

    public static async create( id: number ): Promise<Recurso>
    {
        let o = new Recurso();
        o.Id = id;
        if ( await o.find() )
        {
            return o;
        }
        return null;
    }
    protected Route: string = '/cursos/recursos';
    protected async find(): Promise<boolean>
    {

        this.Existe = false;
        let request = new apiRequest();
        request.path = `${this.Route}/${this.Id}`;
        if ( await request.get() )
        {
            this.Json = request.data;
            this.set();
        }
        return this.Existe;
    }

    public static async find( params: any ): Promise<{ Paginacion: Paginacion, Items: Array<Recurso>; Error?: boolean; }>
    {

        let a: Array<Recurso> = [];
        let paginacion: Paginacion = new Paginacion();
        let request = new apiRequest( `/cursos/recursos` );
        request.params = params;
        if ( await request.get() )
        {
            if ( request.data.response )
            {
                paginacion = new Paginacion( request.data.response );
            }
            if ( request.data.results )
            {
                for ( let i of request.data.results )
                {
                    let p = new Recurso( i );
                    a.push( p );
                }

            }
        }
        return { Paginacion: paginacion, Items: a, Error: request.error };
    }

    public async save(): Promise<boolean>
    {

        try
        {
            let js = this.getJson();
            let req = new apiRequest();
            req.body = js;
            if ( this.Existe )
            {
                req.path = `${this.Route}/${this.Id}`;
                if ( await req.put() )
                {
                    this.Json = req.data;
                    this.set();
                }
            }
            else
            {
                req.path = `${this.Route}`;
                if ( await req.post() )
                {
                    this.Json = req.data;
                    this.set();
                }
            }
            return true;
        } catch ( e )
        {
            Log( e );
        }
        return false;
    }

    public async del(): Promise<boolean>
    {

        try
        {

            if ( this.Existe )
            {
                let req = new apiRequest();
                req.path = `${this.Route}/${this.Id}`;
                if ( await req.delete() )
                {
                    return true;
                }
            }
        } catch ( e )
        {
            Log( e );
        }
        return false;
    }


    public static async subirArchivo( archivo: any ): Promise<string>
    {
        try
        {
            let req = new apiRequest( `/archivo` );
            req.useformData = true;
            req.formData.append( 'file', archivo );
            if ( await req.post() )
            {
                return req.data.id;
            }

        } catch ( e )
        {
            Log( e );
        }
        return '';
    }
}